import { api } from "../lib/api";
import type {
	AvailabilitySlot,
	BulkAvailabilityDay,
	JourneyBookingRequest,
	ScheduledMeeting,
} from "../types/booking";

export async function getAvailableSlots(
	providerId: string,
	date: string,
): Promise<AvailabilitySlot[]> {
	const response = await api.get<AvailabilitySlot[]>(
		"/api/scheduling/available-slots",
		{
			params: { providerId, date },
		},
	);
	return response.data;
}

export async function getBulkAvailability(
	providerId: string,
	startDate: string,
	endDate: string,
): Promise<BulkAvailabilityDay[]> {
	const response = await api.get<BulkAvailabilityDay[]>(
		"/api/scheduling/bulk-availability",
		{
			params: { providerId, startDate, endDate },
		},
	);
	return response.data;
}

export async function createJourneyBooking(
	data: JourneyBookingRequest,
): Promise<ScheduledMeeting> {
	const response = await api.post<ScheduledMeeting>(
		"/api/scheduling/scheduled-meetings",
		data,
	);
	return response.data;
}

const MOCK_SLOTS: Array<{ start: string; end: string; duration: number }> = [
	{ start: "09:00", end: "09:30", duration: 30 },
	{ start: "10:00", end: "10:30", duration: 30 },
	{ start: "11:30", end: "12:00", duration: 30 },
	{ start: "14:00", end: "14:30", duration: 30 },
	{ start: "15:30", end: "16:00", duration: 30 },
];

function toLocalYmd(d: Date): string {
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	return `${y}-${m}-${day}`;
}

export function generateMockAvailability(
	startDate: string,
	endDate: string,
): BulkAvailabilityDay[] {
	const days: BulkAvailabilityDay[] = [];
	const current = new Date(`${startDate}T00:00:00`);
	const end = new Date(`${endDate}T00:00:00`);

	while (current <= end) {
		const dateStr = toLocalYmd(current);
		const dayOfWeek = current.getDay();
		const isWeekday = dayOfWeek !== 0 && dayOfWeek !== 6;

		days.push({
			date: dateStr,
			slots: isWeekday
				? MOCK_SLOTS.map((s, i) => ({
						id: `mock-${dateStr}-${i}`,
						providerId: "demo-provider",
						date: dateStr,
						startTime: s.start,
						endTime: s.end,
						duration: s.duration,
						available: true,
					}))
				: [],
		});

		current.setDate(current.getDate() + 1);
	}

	return days;
}

export function createMockBooking(
	data: JourneyBookingRequest,
): ScheduledMeeting {
	return {
		id: `mock-meeting-${Date.now()}`,
		providerUserId: data.providerUserId,
		patientUserId: data.patientUserId,
		scheduledDate: data.scheduledDate,
		startTime: data.startTime,
		endTime: data.endTime,
		duration: data.duration,
		status: "scheduled",
		title: data.title,
		notes: data.notes,
		journeyTaskId: data.journeyTaskId,
		journeyType: data.journeyType,
		journeyLocale: data.journeyLocale,
		createdAt: new Date().toISOString(),
	};
}
